// src/components/incentives-journey/incentives-journey.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment CollectionClickstreamAnalyticsFragment on CollectionClickstreamAnalytics {\n    event {\n      eventCategory\n      eventName\n      eventType\n      eventVersion\n    }\n    payload {\n      collectionId\n      collectionType\n      componentPosition\n      destinationGeoId\n      productId\n      trackingId\n      componentName\n      componentId\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSButtonFragment on EGDSButton {\n    __typename\n    accessibility\n    primary\n    disabled\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesActionLinkFragment on IncentivesActionLink {\n    resource {\n      value\n    }\n    button {\n      ...EGDSButtonFragment\n    }\n    accessibility\n    impressionAnalytics {\n      linkName\n      referrerId\n    }\n    clickAnalytics {\n      linkName\n      referrerId\n    }\n    presentedAnalytics {\n      ...CollectionClickstreamAnalyticsFragment\n    }\n    selectedAnalytics {\n      ...CollectionClickstreamAnalyticsFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesTileFragment on IncentivesContentItem {\n    incentivesImage {\n      image {\n        url\n        description\n      }\n    }\n    title\n    subtitle\n    actionLink {\n      resource {\n        value\n      }\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      ...IncentivesActionLinkFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesTilesFragment on IncentivesTiles {\n    tiles {\n      ...IncentivesTileFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  query IncentivesJourneyQuery($context: ContextInput!, $selectedIds: [String!]) {\n    incentivesJourney(context: $context, selectedIds: $selectedIds) {\n      ...IncentivesTilesFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
import React7 from "react";
import { gql as gql6, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// ../internal/src/components/incentives-tiles/incentives-tiles.tsx
import React4 from "react";
import { gql as gql5 } from "@apollo/client";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem } from "uitk-react-layout-flex";
// ../internal/src/components/incentives-tile/incentives-tile.tsx
import React3 from "react";
import { gql as gql4 } from "@apollo/client";
import { EgClickstreamImpressionTracker, IntersectionTracker, useClickTracker as useClickTracker2, useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard, UitkCardLink } from "uitk-react-cards";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading, UitkText } from "uitk-react-text";
// ../internal/src/utility/analytics/eg-clickstream-helper.ts
var buildClickstreamAnalyticsEvent = function(clickstreamAnalytics) {
    var _clickstreamAnalytics_event = clickstreamAnalytics.event, eventName = _clickstreamAnalytics_event.eventName, eventType = _clickstreamAnalytics_event.eventType, eventVersion = _clickstreamAnalytics_event.eventVersion, eventCategory = _clickstreamAnalytics_event.eventCategory;
    var _clickstreamAnalytics_payload = clickstreamAnalytics.payload, collectionId = _clickstreamAnalytics_payload.collectionId, collectionType = _clickstreamAnalytics_payload.collectionType, productId = _clickstreamAnalytics_payload.productId, destinationGeoId = _clickstreamAnalytics_payload.destinationGeoId, trackingId = _clickstreamAnalytics_payload.trackingId, componentPosition = _clickstreamAnalytics_payload.componentPosition, componentName = _clickstreamAnalytics_payload.componentName, componentId = _clickstreamAnalytics_payload.componentId;
    var productObject = productId ? {
        product_list: [
            {
                product_id: productId
            }
        ]
    } : null;
    var destinationObject = destinationGeoId ? {
        destination: {
            destination_geo_id: destinationGeoId
        }
    } : null;
    var additionalContextObject = componentPosition || componentName || componentId ? {
        additional_context: {
            user_interface: {
                component_position: componentPosition,
                component_id: componentId,
                component_name: componentName
            }
        }
    } : null;
    var baseObject = {
        event: {
            event_name: eventName,
            event_version: eventVersion,
            event_type: eventType,
            event_category: eventCategory
        },
        incentive: {
            collection_id: collectionId,
            collection_type: collectionType.toLowerCase(),
            incentive_tracking_id: trackingId
        }
    };
    return _object_spread({}, baseObject, productObject, destinationObject, additionalContextObject);
};
// ../internal/src/components/incentives-action-link/incentives-action-link.tsx
import React2 from "react";
import { gql as gql3 } from "@apollo/client";
import { useClickTracker, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/utility/analytics/fragments/collection-clickstream-analytics-fragment.ts
import { gql } from "@apollo/client";
var CollectionClickstreamAnalyticsFragment = gql(_templateObject());
// ../internal/src/components/egds-button/egds-button.tsx
import React from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkPrimaryButton, UitkSecondaryButton, UitkTertiaryButton } from "uitk-react-button";
var fragment = gql2(_templateObject1());
var EgdsButton = function(param) {
    var data = param.data, size = param.size, isFullWidth = param.isFullWidth, onClickHandler = param.onClickHandler, href = param.href, className = param.className, onClickCapture = param.onClickCapture, inverse = param.inverse;
    var __typename = data.__typename, primary = data.primary, accessibility = data.accessibility, disabled = data.disabled;
    if (!primary) {
        return null;
    }
    var Button = UitkPrimaryButton;
    if (__typename === "UISecondaryButton") {
        Button = UitkSecondaryButton;
    } else if (__typename === "UITertiaryButton") {
        Button = UitkTertiaryButton;
    }
    return /* @__PURE__ */ React.createElement(Button, {
        size: size,
        href: href,
        isFullWidth: isFullWidth,
        onClick: onClickHandler,
        disabled: disabled,
        className: className,
        onClickCapture: onClickCapture,
        inverse: inverse
    }, primary, /* @__PURE__ */ React.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility));
};
EgdsButton.fragment = fragment;
EgdsButton.displayName = "EgdsButton";
// ../internal/src/components/incentives-action-link/incentives-action-link.tsx
var __fragment = gql3(_templateObject2(), CollectionClickstreamAnalyticsFragment, EgdsButton.fragment);
var IncentivesActionLink = function(props) {
    var data = props.data, className = props.className, buttonSize = props.buttonSize, buttonIsFullWidth = props.buttonIsFullWidth, buttonClickHandler = props.buttonClickHandler, additionalUisPrimeMicroMessages = props.additionalUisPrimeMicroMessages, visuallyHidden = props.visuallyHidden, multiArmBanditTrack = props.multiArmBanditTrack, inverseButton = props.inverseButton;
    var accessibility = data.accessibility, resource = data.resource, clickAnalytics = data.clickAnalytics, button = data.button, selectedAnalytics = data.selectedAnalytics;
    var track = useEgClickstream();
    var clickTracker = useClickTracker();
    var onClickCapture = function() {
        if (selectedAnalytics) {
            track(buildClickstreamAnalyticsEvent(selectedAnalytics));
        }
        multiArmBanditTrack === null || multiArmBanditTrack === void 0 ? void 0 : multiArmBanditTrack();
        if (clickAnalytics.referrerId) {
            clickTracker(clickAnalytics.referrerId, clickAnalytics.linkName, void 0, additionalUisPrimeMicroMessages);
        }
    };
    if (button) {
        return /* @__PURE__ */ React2.createElement(EgdsButton, {
            data: button,
            href: resource.value,
            size: buttonSize,
            isFullWidth: buttonIsFullWidth,
            className: className,
            onClickHandler: buttonClickHandler,
            onClickCapture: onClickCapture,
            inverse: inverseButton
        });
    }
    return /* @__PURE__ */ React2.createElement("a", {
        href: resource.value,
        onClickCapture: onClickCapture,
        className: className
    }, /* @__PURE__ */ React2.createElement("span", {
        className: visuallyHidden ? "is-visually-hidden" : ""
    }, accessibility));
};
IncentivesActionLink.displayName = "IncentivesActionLink";
IncentivesActionLink.fragment = __fragment;
// ../internal/src/components/incentives-tile/layout-values.ts
var tileSpacingMargin = {
    blockstart: "three"
};
var tileSpacingPadding = {
    blockstart: "one"
};
// ../internal/src/components/incentives-tile/incentives-tile.tsx
var __fragment2 = gql4(_templateObject3(), IncentivesActionLink.fragment);
var IncentivesTile = function(param) {
    var data = param.data, className = param.className;
    var clickTracker = useClickTracker2();
    var track = useEgClickstream2();
    var incentivesImage = data.incentivesImage, title = data.title, subtitle = data.subtitle, actionLink = data.actionLink;
    var image = incentivesImage.image;
    var handleClickCapture = function() {
        var analytics = actionLink.analytics;
        if (analytics) {
            clickTracker("".concat(analytics.referrerId, ".selected"), "click");
        }
        if (actionLink.selectedAnalytics) {
            track(buildClickstreamAnalyticsEvent(actionLink.selectedAnalytics));
        }
    };
    var tileContent = /* @__PURE__ */ React3.createElement(UitkSpacing, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React3.createElement(UitkCard, null, /* @__PURE__ */ React3.createElement(UitkFigure, {
        ratio: UitkFigureAspectRatioType.R3_2,
        roundcorner: true
    }, /* @__PURE__ */ React3.createElement(UitkImage, {
        placeholderImage: true,
        alt: image.description,
        src: image.url
    })), /* @__PURE__ */ React3.createElement(UitkCardLink, null, /* @__PURE__ */ React3.createElement("a", {
        href: actionLink.resource.value,
        onClickCapture: handleClickCapture
    }, actionLink.accessibility || title)), /* @__PURE__ */ React3.createElement(UitkSpacing, {
        margin: tileSpacingMargin
    }, /* @__PURE__ */ React3.createElement(UitkLayoutFlex, {
        direction: "column"
    }, subtitle && /* @__PURE__ */ React3.createElement(UitkText, {
        size: 200,
        overflow: "truncate"
    }, subtitle), /* @__PURE__ */ React3.createElement(UitkSpacing, {
        padding: tileSpacingPadding
    }, /* @__PURE__ */ React3.createElement(UitkHeading, {
        tag: "h6",
        size: 6
    }, title))))));
    if (actionLink.presentedAnalytics) {
        return /* @__PURE__ */ React3.createElement(IntersectionTracker, {
            trackOnce: true,
            referrerId: "".concat(actionLink.analytics.referrerId, ".presented"),
            linkName: "impression",
            className: className
        }, /* @__PURE__ */ React3.createElement(EgClickstreamImpressionTracker, {
            trackOnce: true,
            eventData: buildClickstreamAnalyticsEvent(actionLink.presentedAnalytics)
        }, tileContent));
    }
    return /* linkName used to indicate event type */ /* @__PURE__ */ React3.createElement(IntersectionTracker, {
        trackOnce: true,
        referrerId: "".concat(actionLink.analytics.referrerId, ".presented"),
        linkName: "impression",
        className: className
    }, tileContent);
};
IncentivesTile.fragment = __fragment2;
IncentivesTile.displayName = "IncentivesTile";
// ../internal/src/components/incentives-tiles/layout-values.ts
var tilesGrid = {
    columns: {
        small: 1,
        medium: 2
    },
    space: "six"
};
var tilesSpacing = {
    padding: {
        small: {
            blockend: "six"
        },
        medium: {
            blockend: "unset"
        }
    }
};
var tileSpacingMargin2 = {
    blockstart: "three"
};
var mapGridColumnToWidth = function(columns) {
    switch(columns){
        case 1:
            return "full_width";
        case 2:
            return "third_width";
        case 3:
            return "quarter_width";
        default:
            return "third_width";
    }
};
var mapGridToFlex = function(columns) {
    if (typeof columns === "object" && !Array.isArray(columns)) {
        var _columns_small = columns.small, small = _columns_small === void 0 ? 1 : _columns_small, _columns_medium = columns.medium, medium = _columns_medium === void 0 ? 2 : _columns_medium;
        return {
            small: mapGridColumnToWidth(small),
            medium: mapGridColumnToWidth(medium)
        };
    }
    return {
        small: mapGridColumnToWidth(1),
        medium: mapGridColumnToWidth(columns)
    };
};
// ../internal/src/components/incentives-tiles/incentives-tiles.tsx
var __fragment3 = gql5(_templateObject4(), IncentivesTile.fragment);
var IncentivesTiles = function(param) {
    var data = param.data, className = param.className, _param_columns = param.columns, columns = _param_columns === void 0 ? tilesGrid.columns : _param_columns, _param_space = param.space, space = _param_space === void 0 ? tilesGrid.space : _param_space;
    if (data.tiles.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React4.createElement(UitkLayoutFlex2, {
        wrap: "wrap",
        direction: "row",
        space: space,
        className: className
    }, data.tiles.map(function(tile, index) {
        return /* @__PURE__ */ React4.createElement(Viewport, {
            key: "incentives-tiles-item-".concat(index)
        }, /* @__PURE__ */ React4.createElement(ViewMedium, null, /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem, {
            grow: 1,
            minWidth: mapGridToFlex(columns).medium
        }, /* @__PURE__ */ React4.createElement(IncentivesTile, {
            data: tile
        }))), /* @__PURE__ */ React4.createElement(ViewSmall, null, /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem, {
            grow: 1,
            minWidth: mapGridToFlex(columns).small
        }, /* @__PURE__ */ React4.createElement(IncentivesTile, {
            data: tile
        }))));
    }));
};
IncentivesTiles.fragment = __fragment3;
IncentivesTiles.displayName = "IncentivesTiles";
// src/components/incentives-journey/incentives-journey-placeholder.tsx
import React6 from "react";
// ../internal/src/components/incentives-tiles/incentives-tiles-placeholder.tsx
import React5 from "react";
import { UitkFigure as UitkFigure2, UitkFigureAspectRatioType as UitkFigureAspectRatioType2 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex3 } from "uitk-react-layout-flex";
import { UitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkBlockSkeleton, UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
var IncentivesTilePlaceholder = function(param) {
    var className = param.className;
    return /* @__PURE__ */ React5.createElement(UitkLayoutFlex3, {
        direction: "column",
        className: className
    }, /* @__PURE__ */ React5.createElement(UitkFigure2, {
        ratio: UitkFigureAspectRatioType2.R3_2,
        roundcorner: true
    }, /* @__PURE__ */ React5.createElement(UitkBlockSkeleton, {
        type: "rounded"
    })), /* @__PURE__ */ React5.createElement(UitkSpacing2, {
        margin: tileSpacingMargin2
    }, /* @__PURE__ */ React5.createElement(UitkLayoutFlex3, {
        direction: "column",
        space: "two"
    }, /* @__PURE__ */ React5.createElement(UitkLineSkeleton, {
        type: "secondary"
    }), /* @__PURE__ */ React5.createElement(UitkLineSkeleton, null))));
};
IncentivesTilePlaceholder.displayName = "IncentivesTilePlaceholder";
var IncentivesTilesPlaceholder = function(param) {
    var maxItems = param.maxItems, className = param.className;
    return /* @__PURE__ */ React5.createElement(UitkLayoutGrid, _object_spread_props(_object_spread({}, tilesGrid), {
        className: className
    }), _to_consumable_array(Array(maxItems).keys()).map(function(index) {
        return /* @__PURE__ */ React5.createElement(UitkSpacing2, _object_spread_props(_object_spread({}, tilesSpacing), {
            key: index
        }), /* @__PURE__ */ React5.createElement(IncentivesTilePlaceholder, null));
    }));
};
IncentivesTilesPlaceholder.displayName = "IncentivesTilesPlaceholder";
// src/components/incentives-journey/constants.ts
var ViewTypes = /* @__PURE__ */ function(ViewTypes2) {
    ViewTypes2["TILES"] = "tiles";
    ViewTypes2["BANNER"] = "banner";
    return ViewTypes2;
}(ViewTypes || {});
// src/components/incentives-journey/incentives-journey-placeholder.tsx
var IncentivesJourneyPlaceholder = function(param) {
    var viewType = param.viewType, maxItems = param.maxItems, className = param.className;
    switch(viewType){
        case "tiles" /* TILES */ :
            return /* @__PURE__ */ React6.createElement(IncentivesTilesPlaceholder, {
                maxItems: maxItems,
                className: className
            });
        default:
            return null;
    }
};
IncentivesJourneyPlaceholder.displayName = "sharedui-IncentivesJourneyPlaceholder";
// src/components/incentives-journey/incentives-journey.tsx
var __Query = gql6(_templateObject5(), IncentivesTiles.fragment);
var IncentivesJourney = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr, className = props.className, viewType = props.viewType, columns = props.columns;
    var context = useBexApi().context;
    var selectedIds = inputs.selectedIds;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading) {
        var _selectedIds_length;
        return /* @__PURE__ */ React7.createElement(IncentivesJourneyPlaceholder, {
            viewType: viewType,
            maxItems: (_selectedIds_length = selectedIds === null || selectedIds === void 0 ? void 0 : selectedIds.length) !== null && _selectedIds_length !== void 0 ? _selectedIds_length : 1
        });
    }
    if (error || !data || !data.incentivesJourney) {
        return null;
    }
    switch(data.incentivesJourney.__typename){
        case "IncentivesTiles":
            return /* @__PURE__ */ React7.createElement(IncentivesTiles, {
                data: data.incentivesJourney,
                className: className,
                columns: columns
            });
        default:
            return null;
    }
};
IncentivesJourney.displayName = "sharedui-IncentivesJourney";
export { IncentivesJourney, ViewTypes };
//# sourceMappingURL=index.js.map